module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/077-jordan-fa3d4d7fdbb9fc38a59a1146c728f26d.svg";